<div class="modal-outer-wraper mt-4 common-confirm">
    <div class="modal-inner-wraper delete-popup">
        <img src="assets/images/confirm-icon.png" alt="Confirm"/>            
        <h2>Confirmation</h2>
        <p>{{message}}</p>
        <div class="flex justify-content-center gap-2 mb-4 ">
            <p-button label="Yes" class="btn-continue" (onClick)="onConfirm()"></p-button>
            <p-button label="No" class="btn-delete" styleClass="p-button-outlined" (onClick)="onCancel()"></p-button>
        </div>
    </div>
</div>

  